import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Dashboard from '../views/Dashboard.vue'
import Login from '../views/Login.vue'
import ForgotPassword from '../components/ForgotPassword.vue'
import NotFound from '../components/NotFound.vue'
import AOS from "aos"
import 'aos/dist/aos.css'

import { auth } from '@/firebase/FirebaseInit'

// import store from '@/store/index.js'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },

  {
    path: '/login',
    name: 'Login',
    component: Login
  },

  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta : {
      requiresAuth: true,
    }
  },

  {
    path: '/forgotten-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  document.title = 'Ejikeme David';
  if(to.matched.some(record => record.meta.requiresAuth) && !auth.currentUser) {
    next('/login')
    return;
  };
  AOS.init();
  next();
});

export default router
